import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "done_active-1",
  "use": "done_active-1-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"done_active-1\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.3977 26.5485L8.53693 19.4963L6.25 21.847L15.3977 31.25L35 11.1007L32.7131 8.75L15.3977 26.5485Z\" fill=\"#E0E0E0\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol